module.exports = __webpack_public_path__ + "img/modules/assets/img/error.2c65e354350f47124a3c7d2e4f20a9cf.png";